export { default } from "./useAssignmentsGet";
export * from "./useAssignmentsGet";
